import React from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleAbout = () => {
    navigate("/about", { replace: true })
  }
  const handleContact = () => {
    navigate("/contact", { replace: true })
  }
  const handleMission = () => {
    navigate("/mission", { replace: true })
  }
  const handleDemo = () => {
    navigate("/demo", { replace: true })
  }
  const handlePress = () => {
    navigate("/press", { replace: true })
  }
  const handleBlog = () => {
    navigate("/blog", { replace: true })
  }
  return (
    <div>
      <div className="footerWrap">
        <button onClick={handleAbout}>
          {t('about')}
        </button>
        <button onClick={handleContact}>
          {t('contact')}
        </button>
        <button onClick={handleMission}>
          {t('mission')}
        </button>
        <button onClick={handleDemo}>
          {t('demo')}
        </button>
        <button onClick={handlePress}>
          {t('press')}
        </button>
        <button onClick={handleBlog}>
          {t('blog')}
        </button>
        <button onClick={() => navigate('/privacy-policy')}>
          {t('privacy')}
        </button>
        <button onClick={() => navigate('/terms-of-service')}>
          {t('terms')}
        </button>
      </div>
    </div>
  )
}

export default Footer